<template>
    <footer class="foot-wrap">
        <span>&copy; Woshiajuana 2018</span>
        <svg class="foot-link-icon" @click="jumpHandle('https://github.com/Woshiajuana')">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#github-icon"></use>
        </svg>
        <svg class="foot-link-icon" @click="jumpHandle('https://github.com/Woshiajuana')">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#wechart-icon"></use>
        </svg>
        <svg class="foot-link-icon mooc-icon" @click="jumpHandle('https://www.imooc.com/u/2699509')">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#mooc-icon"></use>
        </svg>
        <svg class="foot-link-icon mooc-icon top-icon margin-left" @click="returnTopHandle">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#top-icon"></use>
        </svg>
        <a href="#/" class="foot-link-icon mooc-icon top-icon">
            <svg class="foot-link-svg">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#return-icon"></use>
            </svg>
        </a>
    </footer>
</template>
<script>
    export default {
        methods: {
            jumpHandle (link) {
                window.location.href = link;
            },
            returnTopHandle () {
                this.$nextTick(() => {
                    if (this.$route.meta.close) {
                        document.getElementsByClassName('body-inner')[0].scrollTop = 0;
                    } else {
                        document.getElementsByClassName('view-wrap')[0].scrollTop = 0;
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
    @import '../assets/scss/define';
    .foot-wrap{
        @extend %w100;
        @extend %df;
        height: 22px;
        background-color: #fff;
        box-shadow: 0 0 50px rgba(0,0,0,0.8);
        z-index: 2;
        justify-content: center;
        align-items: center;
        span{
            @extend %c3;
            font-size: 12px;
            margin-right: 5px;
        }
    }
    .foot-link-icon{
        @extend %cp;
        width: 18px;
        height: 18px;
        margin: 0 2px;
        fill: #333;
        &:hover{
            fill: #000;
        }
    }
    .foot-link-svg{
        width: 14px;
        height: 14px;
    }
    .mooc-icon{
        @include br(2px);
        width: 16px;
        height: 16px;
        background-color: #333;
        fill: #fff;
        margin-left: 4px;
        &:hover{
            fill: #fff;
            background-color: #000;
        }
    }
    .margin-left{
        margin-left: 20px;
    }
    .top-icon{
        width: 14px;
        height: 14px;
        padding: 1px;
    }
</style>



// WEBPACK FOOTER //
// src/components/foot-wrap.vue